import { useEffect, useState } from 'react';

export const useDebounce = <T>(value: T, delay: number): [T, boolean] => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  const isDebouncing = !Object.is(value, debouncedValue);

  useEffect(() => {
    // Skip debounce cycle if the value is the same as the debounced value
    if (Object.is(value, debouncedValue)) {
      return;
    }

    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, debouncedValue]);

  return [debouncedValue, isDebouncing];
};
